import { Person } from '@/types/person';
import { SchedulingTarget } from '@/types/scheduleExpectation';

export type Props = {
  initialAppointmentTypeId?: string;
  onClose: VoidFunction;
  onSuccess?: (appointmentTypeId: string) => void;
  open: boolean;
  person: Person;
};

export enum FarDateOption {
  ASAP = 'asap',
  IN_A_FEW_WEEKS = 'in_a_few_weeks',
  PICK_A_DATE = 'pick_a_date'
}

export enum FarModifier {
  NO_LATER_THAN = 'no_later_than',
  NO_EARLIER_THAN = 'no_earlier_than',
  AROUND = 'around',
  EXACTLY = 'exactly'
}

export type FarMode = SchedulingTarget['mode'];
export type FarConstraint = SchedulingTarget['constraint'];
